import type { TFunction } from "i18next";

import type { SessionResultsData, SessionResultsPlayItem } from "./use-session-results.types";

export interface SessionResultsScenarioAnalyticsData {
  scenario_id: number | string | null;
  scenario_title: string | null;
}

const getScenarioId = (playItem: SessionResultsPlayItem | null | undefined, cognitiveResultId: number | null) =>
  playItem?.scenario_id ?? playItem?.id ?? cognitiveResultId ?? null;

const getScenarioTitle = (playItem: SessionResultsPlayItem | null | undefined, currentTab: number, i18n: TFunction) =>
  playItem?.scenario_title ?? playItem?.title ?? playItem?.name ?? i18n("session-results.results.scenario-result-short", { index: currentTab });

export const getSessionResultsScenarioAnalytics = (
  sessionResults: SessionResultsData | null,
  currentTab: number,
  i18n: TFunction
): SessionResultsScenarioAnalyticsData | null => {
  if (!sessionResults || currentTab <= 0) {
    return null;
  }

  const playItem = sessionResults.play_items[currentTab - 1];
  const playItemResult = sessionResults.play_item_results[currentTab - 1];

  return {
    scenario_id: getScenarioId(playItem, playItemResult?.cognitive_result_id ?? null),
    scenario_title: getScenarioTitle(playItem, currentTab, i18n),
  };
};
